import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import './ErrorState.css';

const ErrorState = ({ message, onRetry }) => {
  return (
    <div className="ds-error-state">
      <FontAwesomeIcon icon={faTriangleExclamation} className="ds-error-state-icon" />
      <p className="ds-error-state-message">
        {message || 'Something went wrong while loading this data.'}
      </p>
      {onRetry && (
        <button 
          className="btn btn-outline-primary" 
          onClick={onRetry}
        >
          <FontAwesomeIcon icon={faRotateRight} /> Retry
        </button>
      )}
    </div>
  );
};

export default ErrorState;